export default __webpack_public_path__ + "static/media/icon4.a9bef26d.svg";